import { cva } from '@/styled-system/css';

export const upsellBannerBodyRecipe = cva({
  base: {
    'display': {
      lg: 'inline',
    },
    'marginBlockStart': {
      lgDown: 'none',
    },
    'marginInlineStart': {
      lg: 'tightest',
    },

    '& > .c11n_text': {
      color: 'inherit',
      textStyle: 'body',
      display: {
        lg: 'inline',
      },
    },
    '& > .c11n_paragraph': {
      color: 'inherit',
      textStyle: 'body',
      display: {
        lg: 'inline',
      },
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'text.onHero.neutral',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
